import { css } from '@emotion/react';

const makeAutocompleteStyling = (theme) => {
  return {
    root: css({
      '& .MuiAutocomplete-input': {
        paddingTop: theme.mvf.spacing.medium,
        paddingBottom: theme.mvf.spacing.medium,
      },
    }),
  };
};

export default makeAutocompleteStyling;
